import React, { forwardRef } from 'react';
import { Button } from '../Button';
import styles from './styles.module.scss';

type Props = {
  /** dialogに表示するタイトル */
  title: string;
  /** dialogに表示するメッセージ */
  message?: string;
  /** confirmボタン押下時のcallback関数 */
  onConfirm: () => void;
  /** confirmボタンのテキスト */
  confirmText?: string;
  /** confirmボタンのバリアント */
  confirmButtonVariant?: React.ComponentProps<typeof Button>['variant'];
  /** cancelボタンのテキスト */
  cancelText?: string;
  /** cancelボタンを表示するかどうか */
  showSecondaryButton?: boolean;
};

export const AlertDialog = forwardRef<HTMLDialogElement, Props & { onClose: () => void }>(
  (
    {
      title,
      message,
      confirmText = 'OK',
      confirmButtonVariant = 'primary',
      cancelText = 'キャンセル',
      showSecondaryButton = true,
      onConfirm,
      onClose,
    },
    ref
  ) => {
    const handleOnConfirm = () => {
      /** confirmのcallbackが走った後にdialogをcloseする */
      onConfirm();
      onClose();
    };

    return (
      <dialog ref={ref} role='alertdialog' className={styles.alertDialog}>
        <div className={styles.modalRoot}>
          <h2 className={styles.title}>{title}</h2>
          {message && (
            <div className={styles.descContainer}>
              {message.split('\n').map((str, index) => (
                <React.Fragment key={index}>
                  {str}
                  <br />
                </React.Fragment>
              ))}
            </div>
          )}
          <div className={styles.btnContainer}>
            {showSecondaryButton && (
              <Button variant='outline' onClick={onClose}>
                {cancelText}
              </Button>
            )}
            <Button variant={confirmButtonVariant} onClick={handleOnConfirm}>
              {confirmText}
            </Button>
          </div>
        </div>
      </dialog>
    );
  }
);
